import { Alert, Box, CircularProgress } from "@mui/material";
import { Typography } from "@platform/design-system";

import { ProposalDocument } from "../components/ProposalDocument";

import type {
  CarrierProposal,
  ProposalDocument as ProposalDocumentType,
} from "../types";

interface HistoryTabProps {
  proposals: CarrierProposal[];
  loading: boolean;
  error: string | null;
  ecoRfpId: string;
}

export function HistoryTab({
  proposals,
  loading,
  error,
  ecoRfpId,
}: HistoryTabProps): React.JSX.Element {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={2}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box mt={2}>
      {proposals.map(({ carrier, documents }: CarrierProposal) => (
        <Box key={carrier} mb={2}>
          <Typography variant="body-medium" color="textSecondary" mb={1}>
            <strong>{carrier}</strong>
          </Typography>
          <Box>
            {documents.map((doc: ProposalDocumentType) => (
              <ProposalDocument key={doc.id} doc={doc} ecoRfpId={ecoRfpId} />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
